import React from "react";

import {
  Alert,
  Breakpoints,
  CTA,
  TextAlignment,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextWeight
} from "@vw-marketing/us-components";

import {
  StyledDescriptionContainer,
  StyledErrorContainer,
  StyledErrorHeaderContainer
} from "./styles";
import { useMyVwContext } from "../../../../shared/hooks/use-my-vw-context";

export const CommunicationCenterErrorView = ({ onRetry }: { onRetry?: () => void }) => {
  const { translationHandler } = useMyVwContext();

  return (
    <StyledErrorContainer>
      <StyledErrorHeaderContainer>
        <Alert />
        <TextCustom
          appearance={TextAppearance.label200}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize20,
              fontWeight: TextWeight.regular,
              color: TextColor.primary,
              lineHeight: TextLineHeight.TextLineHeight24,
            },
            [Breakpoints.b1280]: {
              fontSize: TextSize.TextSize24,
              color: TextColor.primary,
              lineHeight: TextLineHeight.TextLineHeight36,
            },
          }}
        >
          {translationHandler('communicationCenter.errorView.Header')}
        </TextCustom>
      </StyledErrorHeaderContainer>
      <StyledDescriptionContainer>
        <TextCustom
          appearance={TextAppearance.copy200}
          style={{
            [Breakpoints.default]: {
              color: TextColor.secondary,
              fontSize: TextSize.TextSize16,
              fontWeight: TextWeight.regular,
              lineHeight: TextLineHeight.TextLineHeight24,
              textAlign: TextAlignment.center,
            },
            [Breakpoints.b1280]: {
              fontSize: TextSize.TextSize20,
              lineHeight: TextLineHeight.TextLineHeight32,
            },
          }}
        >
          {translationHandler('communicationCenter.errorView.description')} {" "}
          <CTA
            tag="button"
            type="button"
            emphasis="tertiary"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onRetry && onRetry();
            }}
          >
            {translationHandler('communicationCenter.errorView.tryAgain')}
          </CTA>
        </TextCustom>
      </StyledDescriptionContainer>
    </StyledErrorContainer>
  )
};
